<div class="bar1">
  <button class="goBack" mat-button (click)="backSceneList()" style="margin-top: auto; margin-bottom: auto;">
      <mat-icon>arrow_back</mat-icon>
  </button>

  <button class="goBack" mat-button (click)="backSceneList()" matTooltip="{{'navigation.exitScene' | transloco}}" style="margin-right: 0; margin-top: auto; margin-bottom: auto;">
      <mat-icon>close</mat-icon>
  </button>
</div>
<div class="edit-component">
  <small class="debug">{{me}}</small>
  <div fxFlex fxLayoutAlign="space-between center" fxLayout="row wrap">
    <div  fxFlex fxLayoutAlign="start center" fxLayout="row wrap" style="gap: 6px;">
      @if (!miniView) {
        <button mat-button (click)="onBackScene()" matTooltip="{{'general.backToScene' | transloco}}" [matTooltipPosition]="'above'">
          <mat-icon>arrow_back</mat-icon>
        </button>
      }
      @if (miniView) {
        <button mat-button class="rotatedExitIconGlobal" (click)="expandPlaylist()" matTooltip="{{'general.expandPlaylist' | transloco}}" [matTooltipPosition]="'above'">
          <mat-icon>settings_overscan</mat-icon>
        </button>
      }
      @if (miniView) {
        <button mat-button (click)="addContent()" matTooltip="{{'general.addContent' | transloco}}" [matTooltipPosition]="'above'">
          <mat-icon>add_photo_alternate</mat-icon>
        </button>
      }
      <button mat-button (click)="toggleScenePreview()"  matTooltip="{{'general.toggleScenePreview' | transloco}}"  [matTooltipPosition]="'above'">
        @if (scenePreviewEnabled) {
          <mat-icon>layers</mat-icon>
        }
        @if (!scenePreviewEnabled) {
          <mat-icon>layers_clear</mat-icon>
        }
      </button>
      @if (!miniView) {
        <button mat-button (click)="addNewPlaylist()" matTooltip="{{'general.addPlaylist' | transloco}}" [matTooltipPosition]="'above'">
          <mat-icon>playlist_add</mat-icon>
        </button>
      }
      @if (!miniView) {
        <button mat-button (click)="addContent()" matTooltip="{{'general.addContent' | transloco}}" [matTooltipPosition]="'above'">
          <mat-icon>add_photo_alternate</mat-icon>
        </button>
      }
      @if (!miniView) {
        <button mat-button (click)="onCopyPlayers();" [disabled]="selectedIndexes.length == 0" matTooltip="{{'general.copy' | transloco}}" [matTooltipPosition]="'above'">
          <fa-icon class="dupAction" [icon]="faCopy"></fa-icon>
        </button>
      }
      @if (!miniView) {
        <button mat-button (click)="onPastePlayers($event);" [disabled]="copiedPlayers.length == 0" matTooltip="{{'general.paste' | transloco}}" [matTooltipPosition]="'above'">
          <fa-icon class="dupAction" [icon]="faPaste"></fa-icon>
        </button>
      }
      @if (!miniView) {
        <button mat-button (click)="onCutPlayers();" [disabled]="selectedIndexes.length == 0" matTooltip="{{'general.cut' | transloco}}" [matTooltipPosition]="'above'">
          <fa-icon class="dupAction" [icon]="faCut"></fa-icon>
        </button>
      }
      <button mat-button (click)="jumpToPlayer(selectedPlayers[0]);" [disabled]="selectedPlayers.length != 1" matTooltip="{{'general.jumpToScene' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>link</mat-icon>
      </button>
      <button mat-button (click)="onClickAlign('left');" [disabled]="selectedIndexes.length == 0" matTooltip="{{'general.alignLeft' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>first_page</mat-icon>
      </button>
      <!-- <button mat-button (click)="onClickAlign('center');" [disabled]="selectedPlayers.length == 0">
      <mat-icon matTooltip="{{'general.alignCenter' | transloco}}">format_align_center</mat-icon>
    </button> -->
    <button mat-button (click)="onClickAlign('right');" [disabled]="selectedIndexes.length == 0" matTooltip="{{'general.alignRight' | transloco}}" [matTooltipPosition]="'above'">
      <mat-icon>last_page</mat-icon>
    </button>
    @if (!miniView && enableUndoRedo) {
      <button mat-button (click)="onClickUndo();" [disabled]="disableUndo" matTooltip="{{'general.undo' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>undo</mat-icon>
      </button>
    }
    @if (!miniView && enableUndoRedo) {
      <button mat-button (click)="onClickRedo();" [disabled]="disableRedo" matTooltip="{{'general.redo' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>redo</mat-icon>
      </button>
    }
    <button mat-button (click)="onRemovePlayers();" [disabled]="selectedIndexes.length==0" matTooltip="{{'general.removeItem' | transloco}}" [matTooltipPosition]="'above'">
      <mat-icon>delete_outline</mat-icon>
    </button>
    @if (!miniView) {
      <button mat-button (click)="toggleSelectAll();" matTooltip="{{'general.toggleSelection' | transloco}}" [matTooltipPosition]="'above'">
        @if (playlistSelection.length > 0) {
          <mat-icon>deselect</mat-icon>
        }
        @if (playlistSelection.length == 0) {
          <mat-icon>select_all</mat-icon>
        }
      </button>
    }
    <div class="d-flex-center" style="gap: 6px;">
      <button mat-button (click)="onClickZoomIn();" [disabled]="zoomIndex === 0" matTooltip="{{'general.zoomIn' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>zoom_in</mat-icon>
      </button>
      <button mat-button (click)="onClickZoomOut();" [disabled]="zoomIndex === zoomLength - 1" matTooltip="{{'general.zoomOut' | transloco}}" [matTooltipPosition]="'above'">
        <mat-icon>zoom_out</mat-icon>
      </button>
      <mat-label style="margin-right: 10px;">[{{1 / zoom * 100 | number: '1.0-0'}}%]</mat-label>
    </div>
  </div>
  <div class="notes">
    @if (!miniView) {
      <div class="select-playlist">
        <mat-form-field>
          <mat-label>{{'general.selectPlaylist' | transloco}}</mat-label>
          <mat-select (selectionChange)="onChangeDropdown($event)" [(value)]="playlistSelection" panelWidth="auto" multiple  panelClass="mat-warn">
            @for (item of playlistOptions; track item) {
              <mat-option [value]="item">{{item.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (propsMinimized) {
      <a mat-icon-button class="buttonBarButt" (click)="toggleMinimize.emit();">
        <mat-icon class="buttonBarIcon" style="transform: rotate(180deg)">double_arrow</mat-icon>
      </a>
    }
  </div>
</div>

<div @fadeIn class="timelineWrap playlistTimeline"
  (mouseout)="onMouseOut()"
  (mouseover)="onMouseOver()">
  @if (playlistSelection.length > 0 && state) {
    <app-playlist-timeline style="overflow: hidden"
      [setTimeLineState]="state"
      [zoom]="zoom"
      [scenePreviewEnabled]="scenePreviewEnabled"
      (clickChannel)="onClickChannel($event)"
      (resizeItems)="onResizeItems($event)"
      (moveItems)="onMoveItems($event)"
      (pastePages)="onPastePlayers($event)"
      (jumpToPlayer)="jumpToPlayer($event)">
    </app-playlist-timeline>
  } @else {
    <div class="empty">Please select playlists what you want to edit...</div>
  }
  <div class="drag-preview-item"></div>
</div>
</div>
